import React from 'react';
import PropTypes from 'prop-types';
import { searchIcon } from './helpers/iconHelpers';
import i18n from 'i18next';

const SearchBar = (props) => {
	const { term, onSearch, placeholder = i18n.t('components.searchBar.placeholderSearch'), children } = props;

	return (
		<div className='search-bar-wrapper'>
			<input
				value={term}
				onChange={onSearch}
				placeholder={placeholder}
				className='vehicle-search'
			/>
			{searchIcon}
			{children}
		</div>
	)
}

SearchBar.propTypes = {
	term: PropTypes.string.isRequired,
	onSearch: PropTypes.func.isRequired,
	placeholder: PropTypes.string
}

export default SearchBar;
